import React, { ButtonHTMLAttributes } from 'react';
import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import { rescheduleTheme } from '../rescheduleTheme';

const StyledTextButton = styled('button')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  minHeight: 52,
  padding: '0 20px',
  border: 'none',
  borderRadius: rescheduleTheme.radii.control,
  background: 'transparent',
  color: rescheduleTheme.textMuted,
  fontFamily: 'inherit',
  fontSize: 15,
  cursor: 'pointer',
  '&:hover:not(:disabled)': { color: rescheduleTheme.text },
  '&:focus-visible': { outline: `2px solid ${rescheduleTheme.brand}`, outlineOffset: 2 },
  '&:disabled': { color: rescheduleTheme.disabledText, cursor: 'not-allowed' },
});

type TextButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { loading?: boolean };

export const TextButton = ({ loading, disabled, children, type = 'button', ...buttonProps }: TextButtonProps) => (
  <StyledTextButton type={type} disabled={disabled || loading} aria-busy={loading || undefined} {...buttonProps}>
    {loading && <CircularProgress size={18} color="inherit" />}
    {children}
  </StyledTextButton>
);
